// extracted by mini-css-extract-plugin
export default {"helpLink":"SetupHelpLink_helpLink__bD-X8"};